
import React, { FC } from 'react';

import Back from '@assets/icons/back';
import IconButton from './IconButton';
import { useNavigation } from '@react-navigation/native';

const BackButton: FC<IconButtonProps> = ({ navigation, ...props }) => {
    navigation = navigation || useNavigation();
    
    if (!navigation && navigation?.canGoBack()) return null;
    
    return <IconButton icon={<Back />} onPress={navigation?.goBack} />;
};

type IconButtonProps = {
  navigation?: any;
};

export default BackButton;